var metaCustomJs = document.querySelector('meta[name="custom-js"]');
let isRailsUjs   = false;

if (metaCustomJs != null) {
  if (metaCustomJs.getAttribute('custom-js') == 'true') {
    isRailsUjs = true;
  }
}

const Rails = (
  await import(`${isRailsUjs ? `https://ga.jspm.io/npm:@rails/ujs@7.0.4/lib/assets/compiled/rails-ujs.js` : `@rails/ujs`}`)
).default

Rails.start()